// @flow

import React from 'react'
import styles from './styles.scss'

type InfoProps = {|
  icon: string,
  title: string,
  description: string,
|}

const Info = (props: InfoProps) => {
  const { icon, title, description } = props
  return (
    <div className={styles.infoSection}>
      <div className={styles.orangeBox}>
        <div>
          <img src={icon} alt={`${title}-icon`} />
        </div>
      </div>
      <div className={styles.textBox}>
        <h3 className={styles.title}>{title}</h3>
        <span className={styles.underline} />
        <p className={styles.paragraph}>{description}</p>
      </div>
    </div>
  )
}

export default Info
